(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('FeasibilityCheckDeleteController',FeasibilityCheckDeleteController);

    FeasibilityCheckDeleteController.$inject = ['$uibModalInstance', 'entity', 'FeasibilityCheck'];

    function FeasibilityCheckDeleteController($uibModalInstance, entity, FeasibilityCheck) {
        var vm = this;

        vm.feasibilityCheck = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            FeasibilityCheck.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
